export default class PinnedNav {
  constructor() {
    this._nav = document.querySelector(".jsPinnedNav");

    if (!this._nav) return;

    // helpers
    this._handlerTimeout = false;
    this._handlerDelay = 200;

    this.reset()

    document.addEventListener("DOMContentLoaded", (event) => {
      this.init();
    });

    this.unload()
  }

  init () {
    this._container = document.querySelector(".jsPinnedNavContainer");
    this._containerHeight = this._container.offsetHeight;
    this._containerRect = this._container.getBoundingClientRect()
    this._containerTrip = this._containerRect.top

    this.handler()
  }

  reset () {
    this._nav.classList.remove("is-fixed")
  }

  unload () {
    window.onbeforeunload = function () {
      window.scrollTo(0,0);
    }
  }

  handler () {
    window.addEventListener("scroll", () => {
      if (window.scrollY > this._containerTrip) {
        this._nav.classList.add("is-fixed")
      }

      if (this._containerTrip > window.scrollY) {
        this._nav.classList.remove("is-fixed")
      }
    })
  }
}
